import { Column, Group } from '@studio/design-system/form';
import { Input } from '@studio/design-system/input';
import type { Credentials as M_Credentials } from '@studio/models/auth';
import { useLatestFn } from '@studio/react-utils/hooks';
import { isNotEmpty, toString } from '@tryiris-ai/js-types';
import type { ReactElement } from 'react';
import type { CredentialsProps } from './types.js';
import { Sel, STag } from '#~/stag/index.js';

/** `<Credentials>` component. */
export const Credentials = ({ credentials, ...props }: CredentialsProps): ReactElement => {
  const current = credentials.value ?? {};

  const set = useLatestFn((nextValue: M_Credentials) => {
    credentials(isNotEmpty(nextValue) ? nextValue : undefined);
  });

  const handleUsernameChange = useLatestFn((value: string) => {
    const username = toString(value);

    if (username !== current.username) {
      set({ ...current, username });
    }
  });

  const handlePasswordChange = useLatestFn((value: string) => {
    const password = toString(value);

    if (password !== current.password) {
      set({ ...current, password });
    }
  });

  return (
    <Column {...props}>
      <Group label='Username' className={props.labelClassName}>
        <Input
          {...STag(Sel.CredentialsEditor, 'username')}
          onChange={handleUsernameChange}
          value={current.username}
          className={props.inputClassName}
          size={props.inputSize}
          placeholder='Username'
        />
      </Group>

      <Group label='Password' className={props.labelClassName}>
        <Input
          {...STag(Sel.CredentialsEditor, 'password')}
          onChange={handlePasswordChange}
          type='password'
          value={current.password}
          className={props.inputClassName}
          size={props.inputSize}
          placeholder='Password'
        />
      </Group>
    </Column>
  );
};
